import apiService from './api';

export interface Instruction {
  id: number;
  title: string;
  content: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  image_url?: string;
}

export interface CreateInstructionData {
  title: string;
  content: string;
  is_active?: boolean;
  image?: File | null;
}

export interface UpdateInstructionData {
  title: string;
  content: string;
  is_active: boolean;
}

const instructionService = {
  // Get all instructions (admin only)
  getAll: async (): Promise<Instruction[]> => {
    const response = await apiService.get<Instruction[]>('/instructions');
    return response.data;
  },

  // Get active instructions (for employees)
  getActive: async (): Promise<Instruction[]> => {
    const response = await apiService.get<Instruction[]>('/instructions/active');
    return response.data;
  },

  // Create new instruction (admin only)
  create: async (data: CreateInstructionData): Promise<Instruction> => {
    const formData = new FormData();
    formData.append('title', data.title);
    formData.append('content', data.content);
    if (data.is_active !== undefined) formData.append('is_active', String(data.is_active));
    if (data.image) formData.append('image', data.image);

    const response = await apiService.post<Instruction>('/instructions', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Update instruction (admin only)
  update: async (id: number, data: UpdateInstructionData): Promise<Instruction> => {
    const response = await apiService.put<Instruction>(`/instructions/${id}`, data);
    return response.data;
  },

  // Delete instruction (admin only)
  delete: async (id: number): Promise<void> => {
    await apiService.delete(`/instructions/${id}`);
  },
};

export default instructionService; 